import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, Refresh2Icon } from '@blade/ui-kit'
import { backClickedAction } from '@root/features/initialization/atoms/common'
import { useTranslation } from '@root/shared/localization'
import { AuthModal, AuthModalHeading } from '@root/shared/ui'
import { InfoMessage, ProfileIcon } from '@root/shared/ui-kit'

type AuthErrorProps = {
  title?: string
  description?: string
  retry: () => void
}

export const AuthError = ({ title, description, retry }: AuthErrorProps) => {
  const { t } = useTranslation()
  const backClicked = useAction(backClickedAction)

  return (
    <AuthModal infoIcon={ProfileIcon} infoMessage={t('auth.info.wallets')}>
      <AuthModalHeading icon={ProfileIcon} onBack={backClicked} />
      <Content>
        <InfoMessage
          variant="dt"
          intent="error"
          iconSize={24}
          title={title ?? t('common.something-went-wrong')}
          description={description ?? t('auth.me-request-error')}
        >
          <ButtonRetry
            variant="ghost"
            size="xxs"
            radius="rounded"
            iconLeft={<Refresh2Icon size={12} />}
            onClick={retry}
          >
            {t('common.retry')}
          </ButtonRetry>
        </InfoMessage>
      </Content>
    </AuthModal>
  )
}

const Content = styled.div`
  --info-color: var(--text-12);
  --info-color-title: var(--text-12);
  --info-color-description: var(--textA-9);
  --info-color-icon: var(--text-11);
  --info-size-font-color: 14px;
  --info-size-font-description: 12px;

  display: grid;
  justify-content: center;
  align-items: center;
  align-content: center;

  grid-template-rows: auto 1fr auto;

  gap: 10px;
  min-width: 285px;

  color: var(--text-11);
  text-align: center;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
`

const ButtonRetry = styled(Button)`
  border-radius: 6px;
  background: var(--backgroundA-6);
  margin-top: 10px;

  color: var(--text-12);
  font-size: 10px;
  gap: 4px;
  font-weight: 400;

  &:hover {
    background: var(--backgroundA-7);
  }
`
